<link rel="stylesheet" href="document-shelf.component.scss">

<!-- Ожидаем подпись поручения агентом. Экспедитору подписывать/отправлять ничего не нужно —
     встречная подпись не требуется. По кнопке можно проверить статус (поллинга нет). -->
<div *ngIf="assignmentState === 'waiting'" class="shelf-wrapper">
  <img ngSrc="assets/icon/warning-icon.svg" alt="" height="24" width="24"/>
  <div class="sign-document-note">
    <div class="title">Ожидаем подпись поручения агентом</div>
    <div class="text">
      Поручение экспедитору сформировано и находится на подписи у агента. Как только
      агент подпишет его, вы сможете скачать подписанный документ и продолжить отгрузку.
      Встречная подпись с вашей стороны не требуется.
    </div>
    <div class="btn">
      <div
        (click)="checkStatus()"
        class="status-button"
        [class.disabled]="checkingStatus"
      >
        {{ checkingStatus ? 'Проверяем…' : 'Проверить статус' }}
      </div>
    </div>
  </div>
</div>

<!-- Поручение подписано агентом — экспедитор скачивает подписанный документ и продолжает отгрузку. -->
<div *ngIf="assignmentState === 'signed'" class="shelf-wrapper">
  <img ngSrc="assets/icon/checked-icon-round.svg" alt="" height="24" width="24"/>
  <div class="sign-document-note">
    <div class="title">Поручение экспедитору подписано</div>
    <div class="text">
      Агент подписал поручение. Скачайте подписанный документ и продолжайте отгрузку.
    </div>
    <div class="btn">
      <ng-container *ngIf="signedAssignmentFile">
        <app-file [file]="signedAssignmentFile">
        </app-file>
      </ng-container>
      <div (click)="downloadSignedAssignment()" class="fake-button">
        <img ngSrc="assets/icon/download-file-icon.svg" alt="" height="24" width="24">
      </div>
      <div (click)="shareSignedAssignment()" class="fake-button">
        <img ngSrc="assets/icon/share-file-icon.svg" alt="" height="24" width="24">
      </div>
    </div>
  </div>
</div>

<div *ngIf="fileCount" class="btn-block">
  <div (click)="navigateToFileList()" class="shelf-nav-btn">
    <img ngSrc="assets/icon/file-icon.svg" alt="" height="24" width="24">
    <div class="text">Документы по заявке</div>
    <div class="file-counter">
      {{ fileCount }}
    </div>
  </div>
</div>
